<div class="filter">
  <div class="grid grid--va-bottom">
    <div class="grid__box grid__box--size-2">
      <app-field>
        <label>Регион</label>
        <app-select-multiple
          [initBy]="filter.regionsSelected"
          [initByKey]="'name'"
          [items]="filter.data.regions"
          [textKey]="'name'"
          (callback)="onChangeRegions($event)"
          [defaultText]="'Выберите регион'"
        ></app-select-multiple>
      </app-field>
    </div>
    <div class="grid__box grid__box--size-2">
      <app-field>
        <label>Филиал</label>
        <app-select-multiple
          [initBy]="filter.branchesSelected"
          [initByKey]="'mb_id'"
          [items]="filter.data.branches"
          [textKey]="'mb_name'"
          (callback)="onChangeBranches($event)"
          [defaultText]="'Выберите филиал'"
          [isDisabled]="!filter.data.branches || !filter.data.branches.length"
        ></app-select-multiple>
      </app-field>
    </div>
    <div class="grid__box grid__box--size-2">
      <app-field>
        <label>Участок</label>
        <app-select-multiple
          [initBy]="filter.sectorsNumbersSelected"
          [initByKey]="'sector_id'"
          [items]="filter.data.sectorNumbers"
          [textKey]="'sector_number_str'"
          (callback)="onChangeSectorsNumbers($event)"
          [defaultText]="'Выберите район'"
          [isDisabled]="!filter.data.sectorNumbers || !filter.data.sectorNumbers.length"
        ></app-select-multiple>
      </app-field>
    </div>
    <div class="grid__box grid__box--size-2">
      <app-field>
        <label>Район</label>
        <app-select-multiple
          [initBy]="filter.districtsSelected"
          [initByKey]="'city_id'"
          [items]="filter.data.districts"
          [textKey]="'new_name'"
          (callback)="onChangeDistricts($event)"
          [defaultText]="'Выберите район'"
          [isDisabled]="!filter.data.districts || !filter.data.districts.length"
        ></app-select-multiple>
      </app-field>
    </div>
    <div class="grid__box grid__box--size-2">
      <app-field>
        <label>Роль участка</label>
        <app-select class="tbl__role"
                    [textKey]="'name'"
                    (callback)="handleSectorRoleChange($event)"
                    [items]="sectorRoleOptions"
                    [defaultText]="'Выберите роль'">
        </app-select>
      </app-field>
    </div>
    <div class="grid__box grid__box--size-min">
      <div class="grid grid--va-middle">
        <div class="grid__box grid__box--size-min">
          <button class="button" type="button" id="appApplyFilterMonitoring" (click)="filter.onApplyFilter()">Применить</button>
        </div>
        <div class="grid__box grid__box--size-min">
          <button class="ctrl link link--dotted-blue-dark" id="appResetFilterMonitoring" (click)="filter.onResetFilter()">Сбросить</button>
        </div>
      </div>
    </div>
  </div>
</div>
